import { styled } from "goober";
import type { ReactNode } from "react";

const StyledHeader = styled("header")`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 12px;
`;

const Horizontal = styled("div")`
  display: flex;
  align-items: center;
`;

const Middle = styled("div")`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
`;

type Props = {
  left?: ReactNode;
  middle?: ReactNode;
  right?: ReactNode;
  logo: ReactNode;
  mobile?: boolean;
};

export function Header({ left, middle, right, logo, mobile }: Props) {
  return (
    <StyledHeader style={mobile ? { padding: 8 } : undefined}>
      <Horizontal
        style={
          mobile ? { minWidth: 0, flex: 1, overflow: "hidden" } : undefined
        }
      >
        {logo}
        {left}
      </Horizontal>
      {middle && !mobile && <Middle>{middle}</Middle>}
      <Horizontal style={mobile ? { flexShrink: 0 } : undefined}>
        {right}
      </Horizontal>
    </StyledHeader>
  );
}
